import api from "./index";

export interface WhereClauseItem {
  key: string;
  value: string;
  operator: string;
}

export interface PatientPaginationPayload {
  curPage: number;
  perPage: number;
  sortBy: string;
  direction: "asc" | "desc";
  whereClause: WhereClauseItem[];
}

export const paginatePatients = async (payload: PatientPaginationPayload) => {
  return api.post("/patient/pagination", payload);
};

export interface CreateUpdatePatientPayload {
  id?: string;
  doctorId: string;
  clinicId: string;
  name: string;
  // For editing we may hold the existing picture URL; actual upload uses multipart file field `profilePictureUrl`
  profilePictureUrl?: string;
  address: string;
  gender: "Male" | "Female" | "Other";
  dob: string;
  age: number;
  contact: string;
  email: string;
  patientObservations: string[];
  treatmentChoice: string;
}

export const createOrUpdatePatient = async (
  payload: FormData
) => {
  return api.post("/patient/create-update", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const DeletePatient = async (id: string) => {
  return api.get(`/patient/delete/${id}`);
};

export const getPatientById = async (id: string) => {
  return api.get(`/patient/getOne/${id}`);
};

export const getAllPatients = async () => {
  return api.get(`/patient/getAll`);
};
